import { CurrentUser } from "features/auth/auth-slice";
import { intersection } from "lodash";

export const hasAccessRestrictions = (
  roles?: string[],
  permissions?: string[]
) => roles || permissions;

export const hasRequiredAccess = (
  currentUser: CurrentUser | null,
  userRoles: string[],
  userPermissions: Record<string, boolean>,
  roles?: string[],
  permissions?: string[]
) =>
  Boolean(
    currentUser &&
      (Boolean(roles && intersection(roles, userRoles).length > 0) ||
        Boolean(permissions?.some((permission) => userPermissions[permission])))
  );

export const parseJWT = (token: string | undefined | null) => {
  if (!token) return undefined;
  try {
    const [, base64Url] = token.split('.');

    if (!base64Url) {
      return undefined;
    }

    const base64 = base64Url.replaceAll('-', '+').replaceAll('_', '/');

    const decoder = new TextDecoder('utf-8');
    const binaryString = atob(base64);

    const bytes = Uint8Array.from(binaryString, (char) => char.charCodeAt(0));

    const jsonPayload = decoder.decode(bytes);

    return JSON.parse(jsonPayload);
  } catch {
    return undefined;
  }
};